import { CSSProperties } from 'react';
import { IconType } from '.';

interface CartProps extends IconType {
  style?: CSSProperties;
}

export default function Trash({ color = '#000000', className = '', height = 13.714, style, width = 12 }: CartProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 12 13.714" style={style} className={className}>
      <path
        id="trash-regular"
        fill={color}
        d="M4.744,1.286h2.51a.212.212,0,0,1,.179.1l.509.761H4.058l.509-.761a.219.219,0,0,1,.179-.1Zm4.744.857L8.5.667A1.506,1.506,0,0,0,7.256,0H4.744A1.506,1.506,0,0,0,3.5.667L2.513,2.143H.643a.643.643,0,0,0,0,1.286H.954l.643,8.7a1.715,1.715,0,0,0,1.709,1.588H8.695A1.715,1.715,0,0,0,10.4,12.126l.643-8.7h.311a.643.643,0,1,0,0-1.286H9.488Zm.271,1.286-.638,8.6a.428.428,0,0,1-.429.4H3.305a.431.431,0,0,1-.429-.4l-.635-8.6H9.758Z"
      />
    </svg>
  );
}
